import {
  NestedConstrainedListSearchFilterDTO,
  NestedConstrainedListSearchFilterId,
  SearchFilterDTO,
} from "../../types";

const nestedConstrainedListSearchTypes: Record<NestedConstrainedListSearchFilterId, true> = {
  "amenities-type-filter": true,
  "use-class-nested-id": true,
  "power-type-id": true,
  "traffic-count-id": true,
};

export const isNestedConstrainedListSearchDTO = (
  filter: SearchFilterDTO
): filter is NestedConstrainedListSearchFilterDTO => {
  return filter.id in nestedConstrainedListSearchTypes;
};
